export function Courier({ ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <g transform="translate(-150 -689)">
        <rect width="24" height="24" transform="translate(150 689)" fill="none" />
        <g transform="translate(-715 517)">
          <g
            transform="translate(865 172)"
            fill="#fff"
            stroke="currentColor"
            strokeWidth="1"
            opacity="0"
          >
            <rect width="24" height="24" stroke="none" />
            <rect x="0.5" y="0.5" width="23" height="23" fill="none" />
          </g>
          <path
            d="M892.8,5834.719h2.1a1.784,1.784,0,0,1,.434.027.7.7,0,0,1,.26.109,1.932,1.932,0,0,1,.325.29l3.656,3.679a1.9,1.9,0,0,1,.29.326.958.958,0,0,1,.107.263,1.947,1.947,0,0,1,.025.435v2.574a2.236,2.236,0,0,1-.068.8.883.883,0,0,1-.487.489,2.122,2.122,0,0,1-.795.073m-4.5,0H892.8m0,0V5834.9a4.55,4.55,0,0,0-.2-1.913,1.824,1.824,0,0,0-.787-.788,4.4,4.4,0,0,0-1.9-.2h-5.04a4.4,4.4,0,0,0-1.9.2,1.824,1.824,0,0,0-.787.788,4.55,4.55,0,0,0-.2,1.913v7.068a1.809,1.809,0,0,0,1.8,1.813m9,0h-3.6m0,0a2.7,2.7,0,1,1-5.4,0m5.4,0a2.7,2.7,0,1,0-5.4,0m14.85.453a2.25,2.25,0,1,1-2.25-2.266A2.258,2.258,0,0,1,898.65,5844.234Z"
            transform="translate(-14 -5655)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </svg>
  );
}
